import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const buttonTabBarProps = {
  variant: 'tab',
  color: 'white',

  sx: {
    pb: '2',
    '&&[data-active="true"]': {
      bg: 'alpha.400',
      borderBottom: 'none',
      '&>span': {
        borderRadius: 'md',
        padding: '1',
        bg: '#292929',
        color: 'alpha.400',
      },
    },
    '&&[data-active]': {
      borderBottom: 'none',
    },
    '&.subTab': {
      color: '#292929',
    },
  },
};

export const BoxWrapper: CSSObject = {
  bg: 'blackAlpha.400',
  px: '4',
  mx: ['-2', '0'],
  mt: '0',
  mb: '0',
  borderRadius: ['none', 'md'],

  '&:has(+ .subTabBar)': {
    borderBottomRadius: 'none',
  },

  '&.subTabBar': {
    bg: 'alpha.400',
    borderBottomRadius: ['none', 'md'],
    borderTopRadius: 'none',
  },
};

export const buttonTabBarMeetingsProps: CustomButtonProps = {
  variant: 'tab',
  flex: '0 0 auto',
};

export const tickForToteMulti: CSSObject = {
  position: 'absolute',
  width: '11px',
  height: '11px',
  bg: 'beta.100',
  top: '-5px',
  right: '-5px',
  borderRadius: '3px',

  _before: {
    content: "' '",
    height: '5px',
    width: '2px',
    backgroundColor: 'beta.700',
    position: 'absolute',
    top: '2px',
    right: '3px',
    transform: 'rotate(45deg)',
  },

  _after: {
    content: "' '",
    height: '2px',
    width: '4px',
    backgroundColor: 'beta.700',
    position: 'absolute',
    top: '6px',
    right: '5px',
    transform: 'rotate(210deg)',
  },
};
